import { ReactComponent as HomeIcon } from '../../../Asset/sidenavIcons/home.svg';
import { School as SchoolIcon, Logout as LogoutIcon } from '@mui/icons-material';
import { ListItemButton, ListItemIcon, ListItemText, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import routes from '../../../Utils/routes';
import { useStyles } from '../styles';
import LearnIcon from '../../../Asset/Icons/icon.png';
import LogoutIconPng from '../../../Asset/Icons/logout.png';

interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
}

const SideNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const activePath = pathname.split('/')[1]; // Get the first path segment

  console.log(activePath, "activePath")

  console.log('Logout Link:', routes.login); // Debugging

  const sideNavContents = [
    {
      icon: (isActive: boolean) => <HomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Home',
      link: routes.home,
      name: 'home',
    },
    {
      icon: (isActive: boolean) => (
        <img 
        src={LearnIcon} 
        alt="Learn" 
        className={isActive ? classes.listItemIconActive : classes.listItemIcon} 
        style={{ width: 24, height: 24 }} // Adjust size as needed
      />
      ),
      label: 'Learn',
      link: routes.learn, // Changed from routes.home
      name: 'learn'
    },
  ];

  const logoutItem = {
    icon: (isActive: boolean) => (
      <img 
      src={LogoutIconPng} 
      alt="Learn" 
      className={isActive ? classes.listItemIconActive : classes.listItemIcon} 
      style={{ width: 24, height: 24 }} // Adjust size as needed
    />
    ),
    label: 'Logout',
    link: routes.login,
    name: 'logout',
  };

  console.log(sideNavContents, "sideNavContents")
  return (
    <Box display="flex" flexDirection="column" minHeight="60vh" >
      {/* Main Tabs */}
      <Box flexGrow={1} overflow="auto">
        {sideNavContents.map((item, index) => {
          const isActive =
          item.name === 'learn'
            ? activePath === 'learn' || activePath === 'stepper'
            : activePath === item.name;
          return (<ListItemButton
            key={index}
            onClick={() => handleListClick(item.link, index)}
            className={`${classes.listItemButton} ${isActive? classes.listItemButtonActive : ''}`}
          >
            <ListItemIcon>{item.icon(isActive)}</ListItemIcon>
            <ListItemText className={`${classes.listItemText} ${isActive ? classes.listItemTextActive : ''}`}>
              {item.label}
            </ListItemText>
          </ListItemButton>
        )})}
      </Box>

      {/* Logout at the bottom */}
      <Box>
        <ListItemButton
          onClick={() => handleListClick(logoutItem.link, sideNavContents.length)}
          className={`${classes.listItemButton} ${activePath === logoutItem.name ? classes.listItemButtonActive : ''}`}
        >
          <ListItemIcon>{logoutItem.icon(activePath === logoutItem.name)}</ListItemIcon>
          <ListItemText className={`${classes.listItemText} ${activePath === logoutItem.name ? classes.listItemTextActive : ''}`}>
            {logoutItem.label}
          </ListItemText>
        </ListItemButton>
      </Box>
    </Box>
  );
};

export default SideNavTabs;
